<div class="modal-header flex items-center justify-between border-b border-solid border-base-2 px-6 py-4">
    <div class="flex items-center gap-3">
        <div class="flex h-10 w-10 items-center justify-center rounded-full bg-status-warning/15 text-status-warning">
            <si-icon icon="element-warning" class="text-xl" />
        </div>
        <h2 class="text-title-2 font-semibold text-text-primary" id="energy-dialog-title">
            Siemens Energy Address Library Update
        </h2>
    </div>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="close()"
    ></button>
</div>

<div class="modal-body space-y-4 px-6 py-5 text-base text-text-primary">
    <div class="rounded-lg border border-solid border-status-warning/30 bg-status-warning/10 p-4 leading-relaxed">
        <p class="m-0 font-medium">
            SAL is being replaced by Siemens Energy Address Book (
            <a
                [href]="seabUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="font-semibold text-action-primary underline hover:no-underline"
                >SEAB</a
            >
            ).
        </p>
    </div>

    <div class="space-y-3 leading-relaxed">
        <p class="m-0">
            From <span class="font-semibold">21 September 2026</span>, SAL website will be available in read-only mode.
        </p>
        <p class="m-0">All data creation, modification and inactivation requests must be performed in SEAB.</p>
    </div>

    <div class="flex flex-wrap items-center gap-2 rounded-lg bg-base-1 p-3 text-sm border border-solid border-base-2">
        <span class="text-text-secondary">For further Information please contact:</span>
        <a
            [href]="'mailto:' + contactEmail"
            class="inline-flex items-center gap-1.5 font-semibold text-action-primary underline hover:no-underline"
        >
            <si-icon icon="element-mail" class="text-base" />
            <span>{{ contactEmail }}</span>
        </a>
    </div>
</div>

<div class="modal-footer flex items-center justify-end gap-3 border-t border-solid border-base-2 px-6 py-4">
    <a
        [href]="seabUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-secondary inline-flex items-center gap-2"
    >
        <si-icon icon="element-link" />
        <span>Open SEAB</span>
    </a>
    <button
        class="btn btn-primary"
        type="button"
        [attr.aria-label]="'accessibility.close' | translate"
        (click)="close()"
    >
        Understood
    </button>
</div>
